module.exports = __webpack_public_path__ + "img/15.8.TSS.3f56cf95.png";